var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32122 2.1452C1.26836 2.20784 1.24414 2.27824 1.25119 2.3488C1.25824 2.41936 1.29629 2.48737 1.36122 2.54549L6.98622 7.58299C7.04374 7.63446 7.12052 7.67653 7.20999 7.70558C7.29947 7.73463 7.39896 7.74981 7.49997 7.74981C7.60097 7.74981 7.70047 7.73463 7.78994 7.70558C7.87941 7.67653 7.9562 7.63446 8.01372 7.58299L13.6387 2.54549C13.7036 2.48735 13.7416 2.41932 13.7486 2.34876C13.7556 2.2782 13.7313 2.20779 13.6784 2.14517C13.6255 2.08255 13.5459 2.0301 13.4484 1.99349C13.3508 1.95689 13.239 1.93752 13.125 1.9375L1.87497 1.9375C1.76088 1.93749 1.64896 1.95684 1.55135 1.99345C1.45374 2.03006 1.37415 2.08254 1.32122 2.1452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.3,
    height: 15,
    fill: "white",
    transform: "translate(15) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.68bb0ffd96a59337712766de588b0435.svg";
export { ForwardRef as ReactComponent };